import { render, staticRenderFns } from "./ClientOperationalIndicators.vue?vue&type=template&id=51091af7"
import script from "./ClientOperationalIndicators.vue?vue&type=script&lang=js"
export * from "./ClientOperationalIndicators.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports